import {connect} from 'react-redux';

import ApiReference from '../pages/ApiReference';

const _mapStateToProps = ({app}) => ({
    isLoading: app.isLoading,
});

export default connect(
    _mapStateToProps
)(ApiReference);
